/**
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
export default class ContactsMenuService {
    _actions;
    constructor() {
        this._actions = [];
    }
    get actions() {
        return this._actions;
    }
    /*
     * Register an action for the contacts menu
     * Actions use NcButton
     */
    addAction(action) {
        this._actions.push(action);
    }
}
